import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { formatCurrency } from '../../utils/formatters';

// Reusable components
const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const FinancialRow = ({ label, valueBRL, valueUSD }) => (
  <TableRow>
    <TableCell component="th" scope="row">
      {label}
    </TableCell>
    <TableCell align="right">{formatCurrency(valueBRL, 'BRL')}</TableCell>
    <TableCell align="right">{formatCurrency(valueUSD, 'USD')}</TableCell>
  </TableRow>
);

/**
 * CustomsValueSection - Displays customs value information
 * Common to all order types
 * @param {Object} props - Component props
 * @param {Object} props.order - Order data
 */
const CustomsValueSection = ({ order }) => {
  if (!order) return null;

  // Get tax calculation data from order
  const taxCalculation = order.latest_tax_calculation || {};

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="CUSTOMS VALUE" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <FinancialRow
                label="Goods FOB Value"
                valueBRL={taxCalculation.fob_value_brl}
                valueUSD={taxCalculation.fob_value_usd}
              />
              <FinancialRow
                label="International Freight"
                valueBRL={taxCalculation.international_freight_cost_brl}
                valueUSD={taxCalculation.international_freight_cost_usd}
              />
              <FinancialRow
                label="International Insurance"
                valueBRL={taxCalculation.international_insurance_brl}
                valueUSD={taxCalculation.international_insurance_usd}
              />
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                <TableCell component="th" scope="row">
                  <Typography fontWeight="bold">Customs Value</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.valor_aduaneiro_brl)}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.valor_aduaneiro_usd, 'USD')}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default CustomsValueSection;